export default __webpack_public_path__ + "static/media/awards-thumbnail-doc.07f9980e.png";